import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeWrapperProps } from "../types";
import { lightTheme, darkTheme } from "../lib/themes";

export function ThemeWrapper({ children, isDarkMode }: ThemeWrapperProps) {
  return (
    <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
